import React from "react";
import { SITE } from "../lib/site";
import { Eye, Target, Sprout } from "lucide-react";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-20 sm:py-32 bg-[#FAF5F0]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-20 items-start">
          {/* Left — eyebrow + heading */}
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.24em] font-semibold text-[#064E3B]">
              About the Foundation
            </div>
            <div className="pill-divider mt-4" />
            <h2 className="font-serif-display text-3xl sm:text-5xl mt-6 leading-[1.1] text-[#111827] font-semibold">
              A trust built on{" "}
              <span className="italic text-[#064E3B]">faith</span>, sustained by{" "}
              <span className="italic text-[#DC2626]">action</span>.
            </h2>
            <p className="mt-5 sm:mt-6 text-base sm:text-lg text-[#374151] leading-relaxed">
              Alisaafaat Welfare Foundation is committed to addressing the spiritual,
              educational and socioeconomic needs of our community through projects
              that are sustainable, ethical and deeply rooted in Islamic values — with
              the help of Allah and the support of donors and volunteers.
            </p>

            <div className="mt-10 inline-flex flex-col gap-1 border-l-2 border-[#D4AF37] pl-5">
              <span className="text-xs uppercase tracking-[0.18em] text-[#064E3B] font-semibold">
                Account Name
              </span>
              <span className="font-serif-display text-xl text-[#111827]">
                Alisaafaat Welfare Foundation
              </span>
            </div>
          </div>

          {/* Right — vision/mission/values */}
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            <ValueCard
              Icon={Eye}
              title="Our Vision"
              text={SITE.vision}
              accent="#064E3B"
            />
            <ValueCard
              Icon={Target}
              title="Our Mission"
              text={SITE.mission}
              accent="#DC2626"
            />
            <ValueCard
              Icon={Sprout}
              title="Our Approach"
              text="Sustainable, ethical projects rooted in Islamic values — education, dignity, and halal income for those we serve."
              accent="#D4AF37"
            />
            <div className="rounded-3xl bg-[#064E3B] text-white p-8 relative overflow-hidden">
              <div className="absolute -bottom-12 -right-12 h-44 w-44 rounded-full bg-[#065F46]" />
              <div className="absolute inset-0 geo-overlay-light opacity-50" />
              <div className="relative">
                <div className="text-[11px] uppercase tracking-[0.22em] text-[#FCD34D] font-semibold">
                  Strategic Plan
                </div>
                <div className="mt-3 font-serif-display text-3xl sm:text-4xl font-semibold leading-tight">
                  2025 – 2035
                </div>
                <p className="mt-2 text-white/85 text-sm leading-relaxed">
                  A decade of building schools, an orphanage, a clinic, and waqf
                  projects — in shā'a Allāh.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function ValueCard({ Icon, title, text, accent }) {
  return (
    <div
      data-testid={`value-${title.toLowerCase().replace(/\s+/g, "-")}`}
      className="group rounded-3xl border border-[#E5E0DA] bg-white p-7 transition-all hover:-translate-y-1 hover:shadow-lg"
    >
      <div
        className="inline-flex items-center justify-center h-12 w-12 rounded-2xl mb-5"
        style={{ backgroundColor: `${accent}15`, color: accent }}
      >
        <Icon size={22} strokeWidth={1.75} />
      </div>
      <h3 className="font-serif-display text-2xl text-[#111827] font-semibold">
        {title}
      </h3>
      <p className="mt-3 text-[#374151] leading-relaxed">{text}</p>
    </div>
  );
}
